<template>
  <v-card class="form-2fa" style="border-radius: 10px;">
    <div style="display:flex; justify-content: flex-end; padding: 10px;">
      <span @click="$emit('on-close')">
        <v-icon class="close-icon">close</v-icon>
      </span>
    </div>
    <div  class="title-2fa" style="background-color: var(--background-color); border-radius: 10px; border-radius: 10px">
      <div class="rounded-lg text-xs-center">
        <page-title :header="l('Autenticação de Dois Fatores')" subheader="" />
      </div>
      <v-container>
        <h2>{{l('Como usar o Google Authenticator para Autenticação de Dois Fatores')}}</h2>
        <div class="my-5">
          <p>
              <span class="step-number">1)</span>
            {{l('Baixe o aplicativo')}}
            <a
              color="var(--secondary-button-background-color)"
              href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2"
              target="_blank"
              rel="noopener noreferrer"
            >
              Google Authenticator
            </a>
          </p>
          <br />
          <p>
            <span class="step-number">2)</span>

            <a
              href="https://support.google.com/accounts/answer/1066447?co=GENIE.Platform%3DAndroid"
              target="_blank"
              rel="noopener noreferrer"
            >
              Configure
            </a>
            {{l('o aplicativo Google Authenticator')}}
          </p>
            <br />
          <p>
            <span class="step-number">3)</span>
            {{l('Escaneie o QR Code abaixo e clique no botão "Prosseguir" no final desta janela')}}
          </p>
        </div>

        <p v-if="qrCodeValue === null" style="margin:auto; padding-bottom:20px;">
          <a href="" @click.stop.prevent="loadSecret()">
            {{l('Ver QR Code')}}
          </a>
        </p>
        <div v-else>
          <div v-if="displayQrCode" class="qr-code-container">
            <qrcode
              :value="qrCodeValue"
              :options="{width: 300}"
            ></qrcode>
            <p>
              <a href="" @click.stop.prevent="displayQrCode = false">
                {{l('Mostrar Texto')}}
              </a>
            </p>
          </div>
          <div v-else class="secret-text-container">
            <p>{{ secret }}</p>
            <p>
              <a href="" @click.stop.prevent="displayQrCode = true">
                {{l('Mostrar QR Code')}}
              </a>
            </p>
          </div>
          <v-btn
            class="btn-foward"
            dark
            @click.stop.prevent="openModal()"
          >
            <h3> {{l('Prosseguir')}}</h3>
          </v-btn>
        </div>
        <br/>

      </v-container>
      <v-dialog v-model="dialog" persistent max-width="600">
        <TwoFactorAuthenticationForm ref="form" @on-submit="onFormSubmit" @on-close="closeModal" />
      </v-dialog>
    </div>
  </v-card>
</template>

<script>
import HomeLayout from "./layouts/HomeLayout"
import Title from "./components/Title"
import VueQrcode from '@chenfengyuan/vue-qrcode';
import TwoFactorAuthenticationForm from './components/TwoFactorAuthenticationForm'

export default {
  name: 'TwoFactorAuthenticationSetup',
  components: {
    layout: HomeLayout,
    'page-title': Title,
    qrcode: VueQrcode,
    TwoFactorAuthenticationForm
  },
  data() {
    return {
      loadingSecret: false,
      loadingSubmit: false,
      secret: null,
      qrCodeValue: null,
      displayQrCode: true,
      dialog: false,
    }
  },
  methods: {
    l(str) {
      return this.$root.l(str)
    },
    loadSecret() {
      if(this.loadingSecret) {
        return
      }
      this.loadingSecret = true

      let successCallback = (response) => {
        this.secret = response.body.data
        const username = this.$cookies.get('name')
        const env = this.$root.getEnvironment()
        let issuer = 'FacilitaPay'
        switch(env) {
          case 'dev':
            issuer += ' Dev'
            break;
          case 'sandbox':
            issuer += ' Sandbox'
            break;
        }
        this.qrCodeValue = 'otpauth://totp/' + encodeURI(`${username}?secret=${this.secret}&issuer=${issuer}`)
        this.loadingSecret = false
      }

      let errorCallback = (response) => {
        console.log('errorCallback', response)
        this.loadingSecret = false
      }

      let token = this.$cookies.get('api_token')
      this.$http.get(
        this.$root.urls.twofactorauthentication_secret,
        { headers: { Authorization: `Bearer ${token}` } }
      ).then(successCallback, errorCallback)
    },
    closeModal() {
      this.dialog = false
    },
    openModal() {
      this.dialog = true
      this.$refs.form.onOpen()
    },
    onFormSubmit(code) {
       if(this.loadingSubmit) {
        return
      }
      this.loadingSubmit = true

      let successCallback = (response) => {
        this.loadingSubmit = false
        if(response.body.error) {
          this.$refs.form.raiseError(this.l("O código enviado não esta correto, tente novamente."))
          return
        }
        let expire_at = new Date((new Date).getTime() + 60*12*60000) // 12 hours
        this.$cookies.set('has_2fa_enabled', true, expire_at)
        this.$cookies.set('2fa_authenticated', true, expire_at)
        this.closeModal()
        this.loadingSubmit = false
        this.$router.push('/dashboard')
      }

      let errorCallback = (response) => {
        console.log('errorCallback', response)
        this.loadingSubmit = false
      }

      const payload = {
        secret: this.secret,
        code
      }

      let token = this.$cookies.get('api_token')
      this.$http.post(
        this.$root.urls.twofactorauthentication_secret,
        payload,
        { headers: { Authorization: `Bearer ${token}` } }
      ).then(successCallback, errorCallback)
    },
  },
  metaInfo: {
    title: "Facilita Pay"
  }
}
</script>

<style scoped>
.container {
  text-align: center;
}
h2 {
  letter-spacing: 0.025em;
}
.title-2fa {
  padding-top: 20px;
  color: white !important;
}
.container a {
  font-size: 19px;
  color: var(--secondary-button-background-color);
  margin: 0;

}
.container p {
  margin-bottom: 5px;
  font-size: 16px !important;
  color: hsla(0,0%,100%,.7);
  letter-spacing: 0.05em;
}
.qr-code-container,
.secret-text-container {
  margin-top: 20px;
}
.step-number {
  font-weight: bold;
  font-size: 22px;
  color: var(--navigation-color) !important;
  padding-right: 5px;
}
.btn-foward{
  background-color:#27DABC !important;
  color: white;
}
.form-2fa{
  height: 100%!important;
  background-color: var(--background-color) !important;

}

.close-icon {
  background-color: var(--background-color);
  color: var(--primary-light-font-color) !important;
}
.close-icon:hover {
  color: var(--secondary-button-background-color) !important;
  cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// src/TwoFactorAuthenticationSetup.vue